<body class="counter-scroll background-wrap-home4 fixed counter-scroll home4 has-one-page">
  <div id="loading-overlay">
    <div class="loader"></div>
  </div>
  <div id="mobile-menu-overlay"></div>
  <header id="header" class="header header-style4 has-menu-model">
    <app-header></app-header>
  </header>
  <!-- header -->

  <div id="content" class="content">
    <div class="homepage-personal">
      <section class="banner-section s4 two-home" id="home">
        <app-banner></app-banner>
        <app-linkedin></app-linkedin>
      </section><!-- banner-section -->


      <app-about-me></app-about-me>

      <!-- about-me -->


      <app-contact></app-contact>
      <!-- get-project -->


      <app-education></app-education>
      <!-- flat-education -->


      <div id="footer-widget" class="border-bottom-s1 position-relative">
        <h3 class="widget-title larger lt-sp06 text-white text-center pb-5"> </h3>
      </div>
      <app-portfolio></app-portfolio>
      <!-- flat-case-study -->

      <div class="tf-modal-content justify-content-end">
        <app-footer></app-footer>
        <!-- footer -->
      </div>

    </div>
  </div><!-- content -->
  <a id="scroll-top"></a>
</body>
